export default "__VITE_ASSET__CdE3OQdK__"